import { StrictMode, createContext } from "react";
import { createRoot } from "react-dom/client";
import { ApolloProvider } from "@apollo/client/react";
import App from "./App.tsx";
import client from './apollo/client';
import { AuthProvider } from "./context/AuthContext.tsx";
import { AppWrapper } from "./components/common/PageMeta.tsx";
import { ThemeProvider } from "./context/ThemeContext.tsx";
import { ToastProvider } from "./context/ToastContext.tsx";
import { store } from './store'
import "./index.css";
import "swiper/swiper-bundle.css";
import "simplebar-react/dist/simplebar.min.css";

import type { StoreApi } from 'zustand'
import type { AppState } from './store'

export const StoreContext = createContext<StoreApi<AppState> | null>(null);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <StoreContext.Provider value={store}>
      <AuthProvider>
        <ApolloProvider client={client}>
          <ThemeProvider>
            <AppWrapper>
              <ToastProvider>
                <App />
              </ToastProvider>
            </AppWrapper>           
          </ThemeProvider>
        </ApolloProvider>
      </AuthProvider>
    </StoreContext.Provider>
  </StrictMode>
);
